/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderTag
 */
export interface OrderTag {
    /**
     * 
     * @type {string}
     * @memberof OrderTag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTag
     */
    name: string;
}

/**
 * Check if a given object implements the OrderTag interface.
 */
export function instanceOfOrderTag(value: object): value is OrderTag {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OrderTagFromJSON(json: any): OrderTag {
    return OrderTagFromJSONTyped(json, false);
}

export function OrderTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OrderTagToJSON(json: any): OrderTag {
    return OrderTagToJSONTyped(json, false);
}

export function OrderTagToJSONTyped(value?: OrderTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

